export default __webpack_public_path__ + "static/amit-1aee6e731175d58f640d6d391ef3f1b0.png";